import { useTuner } from '@1debit/tuner-web';

import { tunerFlags } from 'utils/features';

/**
 * Hook to check if NuData/NuDetect should be disabled
 * When isNudataDisabled()=true, NuDetect should not be loaded
 *
 * @returns {Object} - { isLoading: boolean, isNudataDisabled: function }
 */
export const useNuDataDisabled = () => {
  const { isFeatureEnabled, loading } = useTuner();

  const isNudataDisabled = () =>
    isFeatureEnabled(tunerFlags.disableNudataEnrollment);

  return {
    isLoading: loading,
    isNudataDisabled,
  };
};
